export default "__VITE_ASSET__DyR8VNCT__"